<template>
  <div id="app">
    <headercomponent/>
    <offers/>
    <formcomponent/>
  </div>
</template>

<script>
import headercomponent from './components/headercomponent.vue'
import offers from './components/offers.vue'
import formcomponent from './components/formcomponent.vue'
export default {
  components: {
    headercomponent,
    offers,
    formcomponent
  }
}
</script>
<style>
@import "assets/fonts/stylesheet.css";
@import "assets/css/lms-form.css";
@import "assets/css/lms-form-custom.css";
@import "assets/css/style.css";
@import "assets/css/offers_new.css";
</style>
